<div class="wrapper-content game-wrapper-full" [class.color-1]="url=='incendios-forestales'"
  [class.color-2]="url=='humedales'"
  [style.background]="(url=='incendios-forestales')?'url('+'/assets/games/fuego-04.jpg'+')':'url('+'/assets/games/humedales-03.jpg'+')'">

  <div class="game-header fullwidth">
    <h5 class="legend">{{url}}</h5>
    <h1 class="title">Jugar ahora</h1>
    <a class="btn-back" (click)="route.goTo('juego-inicio/'+url)" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
              transform="translate(0 36.062) rotate(-45)" fill="#fff" />
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
              transform="translate(3.606 0) rotate(45)" fill="#fff" />
          </g>
        </g>
      </svg>
    </a>
  </div>
  <a (click)="switchStage('prev')" *ngIf="stage>0" class="btn-back-2" style="z-index: 3;background: #ffffff;">
    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
      <g id="Grupo_87" data-name="Grupo 87" transform="translate(-1142 -30)">
        <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
        <path id="Trazado_35" data-name="Trazado 35" d="M2420,308.187l21.85,21.85,21.85-21.85"
          transform="translate(1503.537 -2369.5) rotate(90)" fill="none" stroke="#fff" stroke-width="7" />
      </g>
    </svg>
  </a>
  <div class="container-fluid game-content transparent" style="width:100%">

    <div class="game-options" [class.open]="toolkit" *ngIf="stage==0">
      <a style="position: absolute;top: 0; left: 0;" class="btn-close" (click)="showToolkit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
          <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
            <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85"
              transform="translate(1142 30)" />
            <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
              <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
                transform="translate(0 36.062) rotate(-45)" fill="#fff" />
              <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
                transform="translate(3.606 0) rotate(45)" fill="#fff" />
            </g>
          </g>
        </svg>
        <!-- <svg style="transform: scale(.7); background: bla;
        transform-origin: left top;" xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
          <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z" transform="translate(0 7890)" fill="#fff"/>
        </svg> -->
      </a>
      <p (click)="pickCategory(i)" *ngFor="let area of categories;let i = index"
        [hidden]="i==0 || i==categories.length-1" [class.active]="currentCat == i">{{area.title.es}}</p>
    </div>

    <div class="container-fluid  wrapper-content  col-12 wow fadeInUp" *ngIf="stage==0" data-wow-delay="1s">
      <div class="game-rulette">
        <p (click)="pickCategory(i)" *ngFor="let area of roulette;let i = index"
          [hidden]="i>currentCat+1 || i<currentCat-1 " [class.active]="currentCat == i">{{area.title.es}}</p>
      </div>
      <a style="max-height: 60px;
      min-width: 250px;    position: relative;
    bottom: 30px;
      margin: auto;" (click)="route.goTo('trivia/'+url+'/random')" class="btn-theme ts-background-4">Aleatorio</a>
    </div>

    <div class="wrapper-content  col-12 wow fadeInUp" *ngIf="stage==1" data-wow-delay="1s">
      <svg style="display: block; margin: auto" xmlns="http://www.w3.org/2000/svg" width="140" height="140"
        viewBox="0 0 140 140">
        <g id="Grupo_98" data-name="Grupo 98" transform="translate(-140.83 -207.333)">
          <path id="Trazado_38" data-name="Trazado 38"
            d="M204.769,230.427c16.224,9.523,24.51,23.392,24.5,42.023l1.235.4,5.469-8.961c10.315,14.269,16.045,40.264-2.66,55.21a78.311,78.311,0,0,1-7.29,4.73c1.749-4.266,4.242-8.62,5.265-13.283,1.263-5.754-1.142-11.055-4.653-15.767-2.062-2.769-4.594-5.315-6.1-8.348-2.24-4.524-3.756-9.39-5.629-14.238-9.583,7.722-11.728,18.52-10.968,30.8-5.44-2.476-5.888-6.976-6.454-11.434-7.968,7.634-7.6,22.68.72,31.913-4.165-.617-10.169-5.027-14.03-10.307-8.675-11.862-8.667-27.688.215-40.6,2.856-4.154,6.092-8.063,9.222-12.036,6.448-8.185,10.252-17.3,10.425-27.729a8.521,8.521,0,0,1,.14-1.459C204.219,231.128,204.424,230.946,204.769,230.427Z"
            transform="translate(-0.797 0.204)" fill="#fff" />
          <g id="Grupo_89" data-name="Grupo 89" transform="translate(140.83 207.333)">
            <path id="Trazado_39" data-name="Trazado 39"
              d="M210.83,347.333a70,70,0,1,1,70-70A70.079,70.079,0,0,1,210.83,347.333Zm0-133.05a63.05,63.05,0,1,0,63.05,63.05A63.121,63.121,0,0,0,210.83,214.283Z"
              transform="translate(-140.83 -207.333)" fill="#fff" />
          </g>
        </g>
      </svg>


      <h1 style="text-align: center;color: white; width:100%" *ngIf="category">
        {{category.title.es}} {{category.id}}
        <h5 style="text-align: center;color: white; width:100%">Es la categoría que te toco.</h5>
      </h1>

      <a style="max-height: 60px;
      min-width: 250px;    position: relative;
    bottom: 30px;
      margin: auto;" href="trivia/{{category.id}}" class="btn-theme ts-background-4">Empezar</a>
    </div>

  </div>
</div>
